<template lang="pug">
  main
    NavBarRequisicion
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.is-size-3 Catálogo De Bases De Artículos &nbsp
              a.button.is-black.is-rounded(@click="backPage")
                i.fas.fa-times
            br
        .columns
          .column.is-2
            router-link.a.button.is-black.is-rounded(to='/Inventario/Articulos/Nuevo')
              | Nueva Base De Articulo
          .column.is-offset-6.is-4
            .field
              .control
                input.input.is-primary(
                  type='text', 
                  placeholder='Buscar por Marca|Modelo|Categoría',
                  v-model="query_articulos",
                )
        .columns(v-show="result_query != ''")
          .column.is-offset-8.is-4
            span.tag.is-black.is-small {{ result_query }}
        .columns
          .column.is-12
            TbArticulosBase(:articulos="articulosShow")
</template>

<script>
  import Loader from '../shared/Loader.vue'
  import NavBarRequisicion from './layout/NavBarRequisicion.vue'
  import TbArticulosBase from './TbArticulosBase.vue'

  import InventarioServices from '../../services/inventario/inventario'

  export default {
    name: 'BaseArticulos',
    components: { Loader, NavBarRequisicion, TbArticulosBase },
    data() {
      return {
        isLoading: true,
        articulos: [],
        articulosShow: [],
        query_articulos: '',
        result_query: ''
      }
    }, 
    watch: {
      query_articulos() {
        if (this.query_articulos.length > 0) {
          const QUERY = this.query_articulos.toUpperCase()
          const artFilter = this.articulos.filter( arts => { 
            return `${arts.modelo} ${arts.marca} ${arts.categoria} ${arts.subcategoria}`.toUpperCase().includes(QUERY)
          }) 
          this.articulosShow = artFilter
          this.result_query = this.articulosShow.length === 1 ? `Se encontró ${this.articulosShow.length} coincidencia.` : `Se encontraron ${this.articulosShow.length} coincidencias.`
        } else {
          this.articulosShow = this.articulos
          this.result_query = ''
        }
      }
    },
    methods: {
      iniciarComponente() {
        this.obtenerArticulos()
      },
      obtenerArticulos () {
        InventarioServices.getBaseArticulos()
          .then((data) => {
            this.articulos = data
            this.articulosShow = this.articulos
            this.isLoading = false
          })
          .catch((e) => console.log(e))
      },
      backPage() {
        this.$router.back()
      },
      toUpperCase(e) {
        console.log(e)
        return
      }
    },
    created () {
      this.iniciarComponente()
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/requisiciones_Componentes/BaseArticulos.vue